<script setup>
import { nextTick, onMounted } from 'vue'
import { useToggle } from '@vueuse/core'
import { useTransfer } from '@/composables/complaints'
import item from './form.vue'

const [detailsOpen, showDetailsToggle] = useToggle()

const { firstTransfer, transfer, fetchTransfer, fetchTransfers } = useTransfer()
onMounted(() => {
  fetchTransfers()
})

async function onEdit() {
  transfer.value = { id: firstTransfer.value.id }
  await nextTick()
  await fetchTransfer({ method: 'get' })
  await nextTick()
  showDetailsToggle()
}
async function onclose() {
  transfer.value = {}
  showDetailsToggle(false)
}
</script>
<style>
.first-transfer {
  margin-left: calc(var(--bs-btn-padding-x) * -1);
}
.btn-link {
  padding-left: calc(var(--bs-btn-padding-x) / 2);
  padding-right: calc(var(--bs-btn-padding-x) / 2);
}
</style>
<template>
  <button
    class="btn-link btn first-transfer"
    type="button"
    @click="showDetailsToggle"
    v-if="!firstTransfer"
  >
    Запросить трансфер образца
  </button>
  <div v-else class="d-flex align-items-center flex-wrap">
    По данному обращению есть оформленные трансферы.&puncsp;
    <a href="#" @click.prevent="onEdit">Посмотреть детали</a>&puncsp;или&puncsp;<a
      href="#"
      @click.prevent="showDetailsToggle"
      >Отправить новый запрос</a
    >
  </div>
  <item v-if="detailsOpen" @close="onclose" />
</template>
